//
//
//
//
//
//
//

import { mapState, mapMutations } from "vuex";
import { judgeBrowser } from "../common/js/util";
export default {
  name:'Header',
  data () {
    return {
      showHeader:true
    }
  },
  computed:{
    ...mapState([
      "pageTitle",
      "isLogin"
    ]),
  },
  created(){
    //this.getCode();
  },
  mounted(){
    var that = this;
    if(judgeBrowser()){
        that.showHeader = false;
        document.body.style.paddingTop = '0';
        document.body.className = 'wxchat';
    }else{
        that.showHeader = true;
        document.body.style.paddingTop = '.88rem'
    }
    
  },
   methods:{
    ...mapMutations([
      "setTitle",
      "setLogin"
    ]),
    backPrev(){
      this.$router.back(-1);
    },
    getCode(){
      
    },
  }
}



// WEBPACK FOOTER //
// ./src/components/header.vue